import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'

import { getEnrollmentPickup } from '../../../../api/enrollments/get-enrollment-pickup'
import { useDataProps } from '../../../../lib/hooks/use-data-props'
import { pickupPersonOptionsMapping } from '../../../../lib/types/enums/enrollment/enrollment-pickup'
import {
  EnrollmentPickupBase,
  enrollmentPickupBaseFields
} from '../../../../lib/types/fields/enrollments/enrollment-pickup'
import { DataProps } from '../../../../lib/types/utils'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'
import LoadingScreen from '../../../elements/loading/loading-screen'
import { LabelValue } from './shared-client-space-ui'

export function ClientEnrollmentPickup(props: DataProps<EnrollmentPickupBase>) {
  const { data: enrollmentPickup, isPending } = useDataProps(props, (id) =>
    getEnrollmentPickup(id, enrollmentPickupBaseFields)
  )

  if (!enrollmentPickup || isPending) return <LoadingScreen />

  return (
    <Box className={'border border-grey-light rounded-lg p-4 bg-white-hover'}>
      <Typography variant={'text'}>Informations d'identité de l'enfant</Typography>

      <div className={'mobile:grid-cols-1 grid grid-cols-2 gap-4 mt-3'}>
        <LabelValue
          label={"Sélectionner qui viendra chercher l'enfant"}
          color={tailwindColors.grey.lighter}
        >
          <Typography variant={'tag'}>
            {pickupPersonOptionsMapping[enrollmentPickup.person]}
          </Typography>
        </LabelValue>

        <LabelValue label={'Nom'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>{enrollmentPickup.lastName}</Typography>
        </LabelValue>

        <LabelValue label={'Prénom'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>
            {StringFormatter.capitalize(enrollmentPickup.firstName)}
          </Typography>
        </LabelValue>

        <LabelValue label={'Numéro de téléphone'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>
            {formatPhoneNumber(enrollmentPickup.phoneNumber)}
          </Typography>
        </LabelValue>
      </div>
    </Box>
  )
}
